var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongAspect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77.645096mm",
    height: "52.22731mm",
    viewBox: "0 0 77.645096 52.22731",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-58.009474,-55.023461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.499999,
      paintOrder: "stroke fill markers"
    },
    d: "m 118.16873,59.993022 -33.34291,-4.969561 -3.694886,11.111986 -5.629858,37.317213 34.112824,3.79811 z m -2.70282,2.368516 -7.29051,37.052035 -28.087045,-3.590545 4.703279,-27.604732 2.580041,-10.192763 z m -22.943345,37.233977 2.556152,0.313126 0.788383,2.308669 -1.383513,1.03447 -2.151704,0.0121 -1.358223,-2.03513 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.499999,
      paintOrder: "stroke fill markers"
    },
    d: "m 121.52472,70.007425 6.97083,4.768183 2.66425,10.10216 -2.3574,10.166185 -6.32473,4.536195 -0.18626,-4.274072 -3.31468,7.761624 8.10549,2.48441 -3.27493,-3.41259 7.8252,-5.054259 4.02208,-12.893664 -1.88928,-11.404262 -8.19308,-7.956813 -1.32933,3.586875 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.499999,
      paintOrder: "stroke fill markers"
    },
    d: "m 72.220392,93.85609 -7.720365,-4.85067 -1.979951,-10.2389 2.61225,-10.103702 6.436779,-4.375745 0.07874,4.277403 3.508778,-7.675833 -8.040463,-2.687419 3.188093,3.493856 -7.949803,4.855921 -4.344976,12.788466 1.601952,11.448157 8.44716,8.188398 0.962373,-3.58043 z",
    id: "path2-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongAspect);
export default __webpack_public_path__ + "static/media/WrongAspect.1eeeee00a89f32a6ab8aa2f214edff95.svg";
export { ForwardRef as ReactComponent };